import { APP_PATHS } from "./routes.constants";

export interface LinkItem {
    title: string;
    linkID: number;
    url: string;
    icon: string;
    subtitle?: string;
}

export interface SubLinkItem {
    title: string;
    parentLinkID: number;
    subLinkID: number;
    url: string;
    categoryCode?: string;
    borderColor: string;
}

export const LINKS: LinkItem[] = [
    {
        title: 'NAV.HOME',
        linkID: 1,
        subtitle: 'NAV.HOME_SUB',
        url: APP_PATHS.HOME,
        icon: 'assets/icons/home.svg'
    },
    {
        title: 'NAV.MAP',
        linkID: 2,
        subtitle: 'NAV.MAP_SUB',
        url: APP_PATHS.MAP,
        icon: 'assets/icons/map.svg'
    },
    {
        title: 'NAV.WONDERS',
        linkID: 4,
        subtitle: 'NAV.WONDERS_SUB',
        url: APP_PATHS.WONDERS,
        icon: 'assets/icons/wonders.svg'
    },
    {
        title: 'NAV.SURVEY',
        linkID: 5,
        subtitle: 'NAV.SURVEY_SUB',
        url: APP_PATHS.SURVEY,
        icon: 'assets/icons/encuesta.svg'
    }
];

export const SUBLINKS: SubLinkItem[] = [
    {
        title: 'SUBLINKS.ACCOMMODATIONS',
        parentLinkID: 4,
        subLinkID: 0,
        url: APP_PATHS.ACCOMMODATIONS,
        borderColor: '#FF6B6B'
    },
    {
        title: 'SUBLINKS.ARCHITECTURE',
        parentLinkID: 4,
        subLinkID: 1,
        url: APP_PATHS.WONDERS,
        categoryCode: 'arq',
        borderColor: '#C7CEEA'
    },
    {
        title: 'SUBLINKS.NATURE',
        parentLinkID: 4,
        subLinkID: 2,
        url: APP_PATHS.WONDERS,
        categoryCode: 'natural',
        borderColor: '#6BCB77'
    },
    {
        title: 'SUBLINKS.EVENTS',
        parentLinkID: 4,
        subLinkID: 3,
        url: APP_PATHS.WONDERS,
        categoryCode: 'evento',
        borderColor: '#A8E6CF'
    },
    {
        title: 'SUBLINKS.BEACHES',
        parentLinkID: 4,
        subLinkID: 4,
        url: APP_PATHS.WONDERS,
        categoryCode: 'playa',
        borderColor: '#4ECDC4'
    },
    {
        title: 'SUBLINKS.TOWNS',
        parentLinkID: 4,
        subLinkID: 5,
        url: APP_PATHS.WONDERS,
        categoryCode: 'pueblo',
        borderColor: '#FFD93D'
    },
    {
        title: 'SUBLINKS.TRAILS',
        parentLinkID: 4,
        subLinkID: 6,
        url: APP_PATHS.WONDERS,
        categoryCode: 'sendero',
        borderColor: '#C7CEEA'
    },
    {
        title: 'SUBLINKS.ALL_WONDERS',
        parentLinkID: 4,
        subLinkID: 7,
        url: APP_PATHS.WONDERS,
        borderColor: '#FF6B6B'
    }
];
